function linkGenerator(pageNum, path) {
    return {
        path: path,
        query: {page: pageNum}
    };
}

export default linkGenerator;